const QuranDict = {
  1: [
    { value: "Al-Fatihah", text: "Al-Fatihah" },
    { value: "Al-Baqarah", text: "Al-Baqarah" },
  ],
  2: [{ value: "Al-Baqarah", text: "Al-Baqarah" }],
  3: [
    { value: "Al-Baqarah", text: "Al-Baqarah" },
    { value: "Ali 'Imran", text: "Ali 'Imran" },
  ],
  4: [
    { value: "Ali' Imran", text: "Ali' Imran" },
    { value: "An-Nisa'", text: "An-Nisa'" },
  ],
  5: [{ value: "An-Nisa'", text: "An-Nisa'" }],
  6: [
    { value: "An-Nisa'", text: "An-Nisa'" },
    { value: "Al-Ma'idah", text: "Al-Ma'idah" },
  ],
  7: [
    { value: "Al-Ma'idah", text: "Al-Ma'idah" },
    { value: "Al-An'am", text: "Al-An'am" },
  ],
  8: [
    { value: "Al-An'am", text: "Al-An'am" },
    { value: "Al-A'raf", text: "Al-A'raf" },
  ],
  9: [
    { value: "Al-A'raf", text: "Al-A'raf" },
    { value: "Al-Anfal", text: "Al-Anfal" },
  ],
  10: [
    { value: "Al-Anfal", text: "Al-Anfal" },
    { value: "At-Taubah", text: "At-Taubah" },
  ],
  11: [
    { value: "At-Taubah", text: "At-Taubah" },
    { value: "Yunus", text: "Yunus" },
    { value: "Hud", text: "Hud" },
  ],
  12: [
    { value: "Hud", text: "Hud" },
    { value: "Yusuf", text: "Yusuf" },
  ],
  13: [
    { value: "Yusuf", text: "Yusuf" },
    { value: "Ar-Ra'd", text: "Ar-Ra'd" },
    { value: "Ibrahim", text: "Ibrahim" },
  ],
  14: [
    { value: "Al-Hijr", text: "Al-Hijr" },
    { value: "An-Nahl", text: "An-Nahl" },
  ],
  15: [
    { value: "Al-Isra'", text: "Al-Isra'" },
    { value: "Al-Kahf", text: "Al-Kahf" },
  ],
  16: [
    { value: "Al-Kahf", text: "Al-Kahf" },
    { value: "Maryam", text: "Maryam" },
    { value: "Taha", text: "Taha" },
  ],
  17: [
    { value: "Al-Anbiya'", text: "Al-Anbiya'" },
    { value: "Al-Hajj", text: "Al-Hajj" },
  ],
  18: [
    { value: "Al-Mu'minun", text: "Al-Mu'minun" },
    { value: "An-Nur", text: "An-Nur" },
    { value: "Al-Furqan", text: "Al-Furqan" },
  ],
  19: [
    { value: "Al-Furqan", text: "Al-Furqan" },
    { value: "Ash-Syu'ara'", text: "Ash-Syu'ara'" },
    { value: "An-Naml", text: "An-Naml" },
  ],
  20: [
    { value: "An-Naml", text: "An-Naml" },
    { value: "Al-Qasas", text: "Al-Qasas" },
    { value: "Al-'Ankabut", text: "Al-'Ankabut" },
  ],
  21: [
    { value: "Al-Ankabut", text: "Al-Ankabut" },
    { value: "Ar-Rum", text: "Ar-Rum" },
    { value: "Luqman", text: "Luqman" },
    { value: "As-Sajdah", text: "As-Sajdah" },
    { value: "Al-Ahzab", text: "Al-Ahzab" },
  ],
  22: [
    { value: "Al-Ahzab", text: "Al-Ahzab" },
    { value: "Saba'", text: "Saba'" },
    { value: "Fatir", text: "Fatir" },
    { value: "Yasin", text: "Yasin" },
  ],
  23: [
    { value: "Yasin", text: "Yasin" },
    { value: "As-Saffat", text: "As-Saffat" },
    { value: "Sad", text: "Sad" },
    { value: "Az-Zumar", text: "Az-Zumar" },
  ],
  24: [
    { value: "Az-Zumar", text: "Az-Zumar" },
    { value: "Gafir", text: "Gafir" },
    { value: "Fussilat", text: "Fussilat" },
  ],
  25: [
    { value: "Fussilat", text: "Fussilat" },
    { value: "Asy-Syura", text: "Asy-Syura" },
    { value: "Az-Zukhruf", text: "Az-Zukhruf" },
    { value: "Ad-Dukhan", text: "Ad-Dukhan" },
    { value: "Al-Jasiyah", text: "Al-Jasiyah" },
  ],
  26: [
    { value: "Al-Ahqaf", text: "Al-Ahqaf" },
    { value: "Muhammad", text: "Muhammad" },
    { value: "Al-Fath", text: "Al-Fath" },
    { value: "Al-Hujurat", text: "Al-Hujurat" },
    { value: "Qaf", text: "Qaf" },
    { value: "Az-Zariyat", text: "Az-Zariyat" },
  ],
  27: [
    { value: "Az-Zariyat", text: "Az-Zariyat" },
    { value: "At-Tur", text: "At-Tur" },
    { value: "An-Najm", text: "An-Najm" },
    { value: "Al-Qamar", text: "Al-Qamar" },
    { value: "Ar-Rahman", text: "Ar-Rahman" },
    { value: "Al-Waqi'ah", text: "Al-Waqi'ah" },
    { value: "Al-Hadid", text: "Al-Hadid" },
  ],
  28: [
    { value: "Al-Mujadalah", text: "Al-Mujadalah" },
    { value: "Al-Hasyr", text: "Al-Hasyr" },
    { value: "Al-Mumtahanah", text: "Al-Mumtahanah" },
    { value: "As-Saff", text: "As-Saff" },
    { value: "Al-Jumu'ah", text: "Al-Jumu'ah" },
    { value: "Al-Munafiqun", text: "Al-Munafiqun" },
    { value: "At-Tagabun", text: "At-Tagabun" },
    { value: "At-Talaq", text: "At-Talaq" },
    { value: "At-Tahrim", text: "At-Tahrim" },
  ],
  29: [
    { value: "Al-Mulk", text: "Al-Mulk" },
    { value: "Al-Qalam", text: "Al-Qalam" },
    { value: "Al-Haqqah", text: "Al-Haqqah" },
    { value: "Al-Ma'arij", text: "Al-Ma'arij" },
    { value: "Nuh", text: "Nuh" },
    { value: "Al-Jinn", text: "Al-Jinn" },
    { value: "Al-Muzzammil", text: "Al-Muzzammil" },
    { value: "Al-Muddassir", text: "Al-Muddassir" },
    { value: "Al-Qiyamah", text: "Al-Qiyamah" },
    { value: "Al-Insan", text: "Al-Insan" },
    { value: "Al-Mursalat", text: "Al-Mursalat" },
  ],
  30: [
    { value: "An-Naba'", text: "An-Naba'" },
    { value: "An-Nazi'at", text: "An-Nazi'at" },
    { value: "'Abasa", text: "'Abasa" },
    { value: "At-Takwir", text: "At-Takwir" },
    { value: "Al-Infitar", text: "Al-Infitar" },
    { value: "Al-Mutaffifin", text: "Al-Mutaffifin" },
    { value: "Al-Insyiqaq", text: "Al-Insyiqaq" },
    { value: "Al-Buruj", text: "Al-Buruj" },
    { value: "At-Tariq", text: "At-Tariq" },
    { value: "Al-A'la", text: "Al-A'la" },
    { value: "Al-Gasyiyah", text: "Al-Gasyiyah" },
    { value: "Al-Fajr", text: "Al-Fajr" },
    { value: "Al-Balad", text: "Al-Balad" },
    { value: "Asy-Syams", text: "Asy-Syams" },
    { value: "Al-Lail", text: "Al-Lail" },
    { value: "Ad-Duha", text: "Ad-Duha" },
    { value: "Asy-Syarh", text: "Asy-Syarh" },
    { value: "At-Tin", text: "At-Tin" },
    { value: "Al-'Alaq", text: "Al-'Alaq" },
    { value: "Al-Qadr", text: "Al-Qadr" },
    { value: "Al-Bayyinah", text: "Al-Bayyinah" },
    { value: "Az-Zalzalah", text: "Az-Zalzalah" },
    { value: "Al-'Adiyat", text: "Al-'Adiyat" },
    { value: "Al-Qari'ah", text: "Al-Qari'ah" },
    { value: "At-Takasur", text: "At-Takasur" },
    { value: "Al-'Asr", text: "Al-'Asr" },
    { value: "Al-Humazah", text: "Al-Humazah" },
    { value: "Al-Fil", text: "Al-Fil" },
    { value: "Quraisy", text: "Quraisy" },
    { value: "Al-Ma'un", text: "Al-Ma'un" },
    { value: "Al-Kausar", text: "Al-Kausar" },
    { value: "Al-Kafirun", text: "Al-Kafirun" },
    { value: "An-Nasr", text: "An-Nasr" },
    { value: "Al-Lahab", text: "Al-Lahab" },
    { value: "Al-Ikhlas", text: "Al-Ikhlas" },
    { value: "Al-Falaq", text: "Al-Falaq" },
    { value: "An-Nas", text: "An-Nas" },
  ],
};

export default QuranDict;
